const globalOptions = {
    colors: ['#3498db', '#2c3e50', '#e74c3c', '#f1c40f', '#2ecc71'],
    chart: {
        style: {
            fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
        }
    },
    lang: {
        thousandsSep: ' '
    },
    accessibility: {
        enabled: false
    }
}

export default globalOptions